const OPENID_CONNECT_STATE = 'openid-connect-state';
export { OPENID_CONNECT_STATE, };
//# sourceMappingURL=openid-connect-service-constants.js.map